var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_114_3864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.889 1.4291L29.1327 5.15579C29.892 5.40748 30.5526 5.89201 31.0208 6.54054C31.489 7.18908 31.7409 7.96865 31.7408 8.76852V8.76859V18.1116C31.7408 24.0612 28.526 28.1489 25.1933 30.7951C21.8588 33.4428 18.4506 34.6083 18.1847 34.6972C18.1845 34.6973 18.1842 34.6974 18.184 34.6975L17.8404 34.8114L17.509 34.6644L17.5073 34.6636C17.2451 34.5485 13.8526 33.0188 10.5338 30.1922C7.20715 27.3588 4.03711 23.295 4.03711 18.1116V8.76869C4.03711 8.76866 4.03711 8.76862 4.03711 8.76859C4.03729 7.96897 4.28935 7.18972 4.75749 6.54146C5.22566 5.89318 5.88615 5.40885 6.64518 5.15722L6.64521 5.15721L17.889 1.4291Z",
    fill: "#004C93",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_114_3864"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.4444,
    height: 34.4444,
    fill: "white",
    transform: "translate(0.666504 0.888672)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShield);
export default __webpack_public_path__ + "static/media/icon_shield.296c4ff7c852f14af6654bf3c86783ca.svg";
export { ForwardRef as ReactComponent };